import * as types from './actionTypes';
import { getRequest, deleteRequest } from '../../lib/apiUtils';

export function findDuplicateRecipients() {
    return async dispatch => {
        dispatch({ type: types.START_FIND_DUPLICATE_RECIPIENTS });

        const response = await mockFindDuplicates(); //TODO: temp mock

        dispatch({ type: types.FIND_DUPLICATE_RECIPIENTS_COMPLETE, response });
    };
}

export function updateTable(settings) {
    return dispatch => {
        dispatch({ type: types.UPDATE_DUPLICATE_RECIPIENTS_TABLE, settings });
    }
}

export function getDuplicateRecipients(page = 1, results = 12) { //no sort for now: sort = { by: 'name', direction: 'Ascending' }) {
    return async (dispatch, getState) => {
        const settings = { page, results };
        dispatch({ type: types.UPDATE_DUPLICATE_RECIPIENTS_TABLE, settings });

        const requestId = ++getState().duplicateRecipientsTable.currentRequestId;
        dispatch({ type: types.START_GET_DUPLICATE_RECIPIENTS_TABLE_RECORDS, requestId });

        const tableSettings = getState().duplicateRecipientsTable;
        let params = {
            page: tableSettings.page,
            sortBy: tableSettings.sort.by,
            sortDirection: tableSettings.sort.direction,
            results: tableSettings.resultsView
        };

        // const response = await getRequest('/recipients/duplicates', params);
        //TODO: temp mock
        const response = await mockGetDuplicates(params);

        dispatch({ type: types.GET_DUPLICATE_RECIPIENTS_TABLE_RECORDS, ...{ response, requestId } });
    };
}

export function getDuplicateRecipientsDetails(recipientOneId, recipientTwoId) {
    return async dispatch => {
        dispatch({ type: types.START_GET_DUPLICATE_RECIPIENTS_DETAILS });

        const recipients = await Promise.all([
            getRequest(`/recipients/${recipientOneId}`),
            getRequest(`/recipients/${recipientTwoId}`)
        ]);

        const response = {
            loading: false,
            success: recipients.every(recipient => recipient.success), //check that firefox 1.5+ is good.  for .every support
            data: recipients.map(recipient => recipient.data)
        };

        dispatch({ type: types.GET_DUPLICATE_RECIPIENTS_DETAILS, response });
    };
}

export function resolveDuplicateRecipients(deleteRecipientId, keepRecipientId) {
    return async dispatch => {
        dispatch({ type: types.START_RESOLVE_DUPLICATE_RECIPIENTS });

        const response = await deleteRequest(`/recipients/${deleteRecipientId}`, { duplicateId: keepRecipientId });

        dispatch({ type: types.RESOLVE_DUPLICATE_RECIPIENTS, response });
    };
}


//MOCK API CALLS:
async function mockFindDuplicates() {
    await sleep(4000);
    return { success: true, loading: false };
}

async function mockGetDuplicates() {
    await sleep(1500);
    const duplicates = [
        [
            {
                applicantId: 123,
                name: "Chaim Moshe Stern",
                address: "346 Reta Way Suite 132",
                phone: "185-548-0987"
            },
            {
                applicantId: 567,
                name: "Moshe Stern",
                address: "346 Reta Way Suite 132",
                phone: "185-548-0987"
            },
            {
                applicantId: 456,
                name: "Moshe Stern",
                address: "346 Reta Way Suite 132",
                phone: "185-548-0987"
            }
        ],
        [
            {
                applicantId: 432,
                name: "Henry Bloch",
                address: "346 Reta Way Suite 132",
                phone: "185-548-0987"
            },
            {
                applicantId: 987,
                name: "Henry Block",
                address: "346 Reta Way Suite 132",
                phone: "185-548-0987"
            },
            {
                applicantId: 111,
                name: "Moshe Stern",
                address: "346 Reta Way Suite 132",
                phone: "185-548-0987"
            }
        ],
        [
            {
                applicantId: 123,
                name: "Chaim Moshe Stern",
                address: "346 Reta Way Suite 132",
                phone: "185-548-0987"
            },
            {
                applicantId: 5687,
                name: "Moshe Stern",
                address: "346 Reta Way Suite 132",
                phone: "185-548-0987"
            }
        ],
        [
            {
                applicantId: 432,
                name: "Henry Bloch",
                address: "346 Reta Way Suite 132",
                phone: "185-548-0987"
            },
            {
                applicantId: 9187,
                name: "Henry Block",
                address: "346 Reta Way Suite 132",
                phone: "185-548-0987"
            }
        ],
        [
            {
                applicantId: 1223,
                name: "Chaim Moshe Stern",
                address: "346 Reta Way Suite 132",
                phone: "185-548-0987"
            },
            {
                applicantId: 852,
                name: "Moshe Stern",
                address: "346 Reta Way Suite 132",
                phone: "185-548-0987"
            },
            {
                applicantId: 258,
                name: "Moshe Stern",
                address: "346 Reta Way Suite 132",
                phone: "185-548-0987"
            },
            {
                applicantId: 147,
                name: "Moshe Stern",
                address: "346 Reta Way Suite 132",
                phone: "185-548-0987"
            },
            {
                applicantId: 741,
                name: "Moshe Stern",
                address: "346 Reta Way Suite 132",
                phone: "185-548-0987"
            }
        ],
        [
             {
                applicantId: 4732,
                name: "Henry Bloch",
                address: "346 Reta Way Suite 132",
                phone: "185-548-0987"
            },
            {
                applicantId: 9987,
                name: "Henry Block",
                address: "346 Reta Way Suite 132",
                phone: "185-548-0987"
            }
        ],
        [
            {
                applicantId: 1293,
                name: "Chaim Moshe Stern",
                address: "346 Reta Way Suite 132",
                phone: "185-548-0987"
            },
            {
                applicantId: 5967,
                name: "Moshe Stern",
                address: "346 Reta Way Suite 132",
                phone: "185-548-0987"
            }
        ],
        [
            {
                applicantId: 4632,
                name: "Henry Bloch",
                address: "346 Reta Way Suite 132",
                phone: "185-548-0987"
            },
            {
                applicantId: 9837,
                name: "Henry Block",
                address: "346 Reta Way Suite 132",
                phone: "185-548-0987"
            }
        ],
        [
            {
                applicantId: 22123,
                name: "Chaim Moshe Stern",
                address: "346 Reta Way Suite 132",
                phone: "185-548-0987"
            },
            {
                applicantId: 22567,
                name: "Moshe Stern",
                address: "346 Reta Way Suite 132",
                phone: "185-548-0987"
            }
        ],
        [
            {
                applicantId: 43222,
                name: "Henry Bloch",
                address: "346 Reta Way Suite 132",
                phone: "185-548-0987"
            },
            {
                applicantId: 98722,
                name: "Henry Block",
                address: "346 Reta Way Suite 132",
                phone: "185-548-0987"
            }
        ]
    ];

    return {
        loading: false,
        success: true,
        data: {
            totalCount: duplicates.length,
            records: duplicates
        }
    }
}

function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}



// WEBPACK FOOTER //
// ./src/redux/actions/DuplicateRecipientsActions.js